<template>
	<div>
		<AppHeader title="회원 정보 수정" is-history></AppHeader>
		<AppContent>
			<EditUserDetail></EditUserDetail>
		</AppContent>
		<AppFooter></AppFooter>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';
import EditUserDetail from '@/components/EditUserDetail';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		EditUserDetail,
	},
};
</script>
